import { PersonnelProvider } from 'features/Responder/features/Personnel';
import { isResponderMessengerEnabled } from './config/voipFeatureFlag';
import { MessengerShell } from './components/MessengerShell';

/**
 * Main Responder Messenger component (v2 - rebuilt from ground up).
 * Handles SSE, conversations, messages, and UI coordination.
 */
export function ResponderMessenger() {
  if (!isResponderMessengerEnabled()) return null;

  return (
    <PersonnelProvider>
      <MessengerShell />
    </PersonnelProvider>
  );
}

export default ResponderMessenger;
